import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { catchError, EMPTY, Observable, of, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  private handleAuthError(error: HttpErrorResponse): Observable<any> {
    if ([403, 401].includes(error.status)) {
      if (!this.authService.isLoggedIn()) {
        return of(EMPTY);
      }
    }

    return throwError(() => error);
  }

  public intercept(request: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    return handler.handle(request).pipe(catchError((error) => this.handleAuthError(error)));
  }
}
